import {
    InteractiveQuestion,
    QuestionsCollection,
} from '../../api/models/survey';
import {
    getBuiltSurvey,
    SELECTED_QUESTION_GROUP_BUYER,
    shouldIncludeInBasicInfo,
    SurveyQuestion,
} from '../../models/survey';
import { WithSurveyNamespace } from '../../state/survey';
import { createSelector } from '../utils/selector';
import {
    getInteractiveQuestionsByAttendeeId,
    getQuestionsCollection,
} from './pureSelectors';

export const getQuestionsForBasicInfo = createSelector<
    Array<SurveyQuestion>,
    (
        questionsCollection: QuestionsCollection,
        interactiveQuestionsByAttendeeId: Record<
            string,
            Array<InteractiveQuestion>
        >,
    ) => Array<SurveyQuestion>
>(
    (state: WithSurveyNamespace) => getQuestionsCollection(state),
    (state: WithSurveyNamespace) => getInteractiveQuestionsByAttendeeId(state),
    (questionsCollection, interactiveQuestionsByAttendeeId) =>
        getBuiltSurvey(
            questionsCollection,
            interactiveQuestionsByAttendeeId[SELECTED_QUESTION_GROUP_BUYER] ??
                [],
            shouldIncludeInBasicInfo,
        ),
);
